import GoGroupBtn from "./go-group-btn.vue";
export default GoGroupBtn;



// WEBPACK FOOTER //
// ./goingsrc/vueCom/ctlVue/go-group-btn/index.js